// extracted by mini-css-extract-plugin
export default {"deleteModal":"ModalDelete_deleteModal__VIhP0","title":"ModalDelete_title__lQT-N","buttons":"ModalDelete_buttons__lchWO","button":"ModalDelete_button__zSBQ4"};